export default __webpack_public_path__ + "static/publish_background-05cde40c37182c302bac75eb8a84933f.png";